export const FORGET_PARTICIPANT_PASSWORD = "FORGET_PARTICIPANT_PASSWORD"
export const FORGET_PARTICIPANT_PASSWORD_SUCCESS = "FORGET_PARTICIPANT_PASSWORD_SUCCESS"
export const FORGET_PARTICIPANT_PASSWORD_ERROR = "FORGET_PARTICIPANT_PASSWORD_ERROR"
